export type {
    TThunkRejectionError,
    ILoadingStateSliceState,
} from './loading-state-slice';

export {
    loadingStateSliceReducer,
    selectIsThunkPending,
    selectIsThunkRejected,
    selectThunkError,
    selectThunkStatus,
} from './loading-state-slice';

export {LOADING_STATE_SLICE} from './loading-state-slice-constants';
